import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SharedService } from './sharedService';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService{

  constructor(public http: HttpClient, public sharedService: SharedService) { 
    super(http, sharedService);
  }


  getUsernames(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('user/list')).pipe(
      map(res => {
        return res;
      })
    );
  }

  getRegisterators(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('user/registratorlist')).pipe(
      map(res => {
        return res;
      })
    );
  }

  getUserroles(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('user/roles')).pipe(
      map(res => {
        return res;
      })
    );
  }

  getCurrentUser(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('user/current')).pipe(
      map(res => {
        return res;
      })
    );
  }

}



